import { AppModule } from 'app/module';
import './styles.scss';

export class CompanyCardImageLight extends AppModule {
    domBindings() {
        return {
            logo: '.m-companyCardImageLight__logo',
        };
    }

    getPropsFromDom() {
        return {
            hasBranding: this.dom.el.getAttribute('data-hasBranding'),
            image: this.dom.el.getAttribute('data-image') !== 'false' ? this.dom.el.getAttribute('data-image') : false,
            logo: this.dom.logo.getAttribute('data-logo'),
            fallBackLogo: this.dom.logo.getAttribute('data-fallbacklogo'),
        };
    }
}
